<template>
<span>{{ item.title }}</span>
</template>
<script>
export default {
    props: {
        item: {required: true},
        searchText: {required: true}
    }
}
</script>
